import {
  RequestListTeam,
  RequestListOwn,
  RequestListOwnApprove,
  RequestListOwnReject,
  RequestListUrgent,
} from 'src/pages/budget/budgetRequests/widgets'
import { BudgetPeriodState } from 'src/pages/budget/budgetRequests/types'
import { capitalize } from 'lodash'
import dayjs from 'dayjs'

type Props = {
  budgetPeriod: BudgetPeriodState
}

export const RequestListSection = ({ budgetPeriod }: Props) => {
  const { byId, currentPeriodId } = budgetPeriod
  if (!currentPeriodId) return null

  const periodFormatted = byId.get(currentPeriodId)?.periodFormatted
  const budgetPeriodName = periodFormatted
    ? capitalize(dayjs(periodFormatted, 'YYYY-MM').format('MMMM YYYY'))
    : null

  const currentPeriodStatus = byId.get(currentPeriodId)?.status

  return (
    <>
      <RequestListUrgent
        budgetPeriodName={budgetPeriodName}
        currentPeriodStatus={currentPeriodStatus}
      />
      <RequestListTeam
        budgetPeriodName={budgetPeriodName}
        currentPeriodStatus={currentPeriodStatus}
      />
      <RequestListOwnApprove
        budgetPeriodName={budgetPeriodName}
        currentPeriodStatus={currentPeriodStatus}
      />
      <RequestListOwnReject
        budgetPeriodName={budgetPeriodName}
        currentPeriodStatus={currentPeriodStatus}
      />
      <RequestListOwn
        budgetPeriodName={budgetPeriodName}
        currentPeriodStatus={currentPeriodStatus}
      />
    </>
  )
}
